import { Fragment as _Fragment, jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from 'react';
import { useAdBlockInUse } from '../lib/useAdBlockInUse';
/**
 * @description
 * WhenAdBlockInUse will render children if it detects that an ad blocker
 * is being used. It uses useAdBlockInUse which is a function that performs
 * detection checks and returns a promise.
 *
 * Sure, you could just use this custom hook directly but sometimes code is easier
 * to read and understand when conditional rendering is done using composition
 *
 * @param {ReactNode} children - What gets rendered if an ad blocker is in use
 * */
export const WhenAdBlockInUse = ({ children }) => {
    const adBlockerDetected = useAdBlockInUse();
    return adBlockerDetected ? _jsx(_Fragment, { children: children }, void 0) : null;
};
